module.exports = __webpack_public_path__ + "img/sabiba-sign.2ab1044d.png";